import clsx from 'classnames';
import React from 'react';
import './index.scss';

export const NumPad = ({ title, subtitle, value, onClick, className }) => {
  return (
    <div
      className={clsx('dialpad-numpad-wrapper', className)}
      onClick={() => {
        if (typeof onClick === 'function') {
          onClick(value);
        }
      }}
    >
      <span className="title">{title}</span>
      <div className="sub">{subtitle && <span>{subtitle}</span>}</div>
    </div>
  );
};
